const integrationActionConstants = {
  GET_INTEGRATION: 'GET_INTEGRATION',
  GET_INTEGRATION_SUCCESS: 'GET_INTEGRATION_SUCCESS',
  GET_INTEGRATION_ERROR: 'GET_INTEGRATION_ERROR',

  GET_SLACK_AUTHORIZATION: 'GET_SLACK_AUTHORIZATION',
  GET_SLACK_AUTHORIZATION_SUCCESS: 'GET_SLACK_AUTHORIZATION_SUCCESS',
  GET_SLACK_AUTHORIZATION_ERROR: 'GET_SLACK_AUTHORIZATION_ERROR',

  UPDATE_SLACK_USER: 'UPDATE_SLACK_USER',
  UPDATE_SLACK_USER_SUCCESS: 'UPDATE_SLACK_USER_SUCCESS',
  UPDATE_SLACK_USER_ERROR: 'UPDATE_SLACK_USER_ERROR',

  GET_LINKEDIN_ACCOUNTS: 'GET_LINKEDIN_ACCOUNTS',

  DISCONNECT_LINKEDIN_ACCOUNT: 'DISCONNECT_LINKEDIN_ACCOUNT',
};

export default integrationActionConstants;
